// FAQ page: tabs + accordion

jQuery(document).ready(function ($) {
  const $faq = $('.faq');
  if (!$faq.length) return;

  const $tabs = $faq.find('.faq__tab');
  const $panels = $faq.find('.faq__panel');
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const speed = function () {
    return reduceMotion.matches ? 0 : 250;
  };

  function selectTab($tab) {
    $tabs
      .removeClass('active')
      .attr({ 'aria-selected': 'false', tabindex: '-1' });
    $tab.addClass('active').attr({ 'aria-selected': 'true', tabindex: '0' });

    $panels.prop('hidden', true);
    $('#' + $tab.attr('aria-controls')).prop('hidden', false);
  }

  $tabs.on('click', function () {
    selectTab($(this));
  });

  // Arrow / Home / End keys move between tabs
  $tabs.on('keydown', function (e) {
    const index = $tabs.index(this);
    let next = null;

    if (e.key === 'ArrowRight') next = (index + 1) % $tabs.length;
    if (e.key === 'ArrowLeft') next = (index - 1 + $tabs.length) % $tabs.length;
    if (e.key === 'Home') next = 0;
    if (e.key === 'End') next = $tabs.length - 1;
    if (next === null) return;

    e.preventDefault();
    const $next = $tabs.eq(next);
    selectTab($next);
    $next.trigger('focus');
  });

  // Accordion: one open question per tab
  $faq.on('click', '.faq__toggle', function () {
    const $item = $(this).closest('.faq__item');
    const isOpen = $item.hasClass('is-open');

    $item
      .siblings('.is-open')
      .removeClass('is-open')
      .find('.faq__toggle')
      .attr('aria-expanded', 'false')
      .end()
      .find('.faq__answer')
      .stop(true)
      .slideUp(speed(), function () {
        $(this).prop('hidden', true);
      });

    $item.toggleClass('is-open', !isOpen);
    $(this).attr('aria-expanded', String(!isOpen));

    const $answer = $item.find('.faq__answer').stop(true);
    if (isOpen) {
      $answer.slideUp(speed(), function () {
        $(this).prop('hidden', true);
      });
    } else {
      $answer.prop('hidden', false).hide().slideDown(speed());
    }
  });
});
